// extracted by mini-css-extract-plugin
export default {"block":"BlockTitle_block__tnCnD","title":"BlockTitle_title__Qj8qy","count":"BlockTitle_count__wtFTp","error":"BlockTitle_error__5ho6t"};